import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { ZUSTAND_KEY_UNIQUE } from "@/app/lib/constants";

const AUTH_PROFILE_STALE_THRESHOLD_MS = 60 * 60 * 1000;

type AuthSyncState = {
   lastForcedAuthRefreshAt?: number;
   lastExternalProfileSyncedAt?: string;
   setExternalProfileSyncedAt: (syncedAt?: string) => void;
   markForcedAuthRefresh: (syncedAt?: string) => void;
   shouldForceRefreshAuthProfile: () => boolean;
   clearAuthSync: () => void;
};

const isExternalProfileSyncedAtStale = (syncedAt?: string): boolean => {
   if (!syncedAt) return true;
   const syncedAtTime = new Date(syncedAt).getTime();
   if (Number.isNaN(syncedAtTime)) return true;
   return Date.now() - syncedAtTime >= AUTH_PROFILE_STALE_THRESHOLD_MS;
};

export const useAuthSyncStore = create<AuthSyncState>()(
   persist(
      (set, get) => ({
         lastForcedAuthRefreshAt: undefined,
         lastExternalProfileSyncedAt: undefined,
         setExternalProfileSyncedAt: (syncedAt?: string) =>
            set({ lastExternalProfileSyncedAt: syncedAt }),
         markForcedAuthRefresh: (syncedAt?: string) =>
            set({
               lastForcedAuthRefreshAt: Date.now(),
               lastExternalProfileSyncedAt: syncedAt
            }),
         shouldForceRefreshAuthProfile: () =>
            isExternalProfileSyncedAtStale(get().lastExternalProfileSyncedAt),
         clearAuthSync: () =>
            set({
               lastForcedAuthRefreshAt: undefined,
               lastExternalProfileSyncedAt: undefined
            })
      }),
      {
         name: ZUSTAND_KEY_UNIQUE.AUTH_SYNC,
         storage: createJSONStorage(() => localStorage)
      }
   )
);
